import script from "./HomeComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HomeComponent.vue?vue&type=style&index=0&id=2de74ade&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de74ade"]])

export default __exports__